<template>
  <tr class="grid grid-cols-2 grid-flow-row md:table-row">
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Order
    </td>
    <td
      class="px-3 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <a class="text-blue-500" :href="orderUrl" target="_blank">
        {{ order.orderNumber }}
      </a>
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Date
    </td>
    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
    >
      {{ order.createdDate | dateFilter }}
      <div v-if="order.storeId === '661cd1ef47e9075874dca234'">
        <span
          class="px-2 inline-flex text-xs leading-5 font-normal rounded-full "
          :class="{
            'bg-red-100 text-red-800': !order.isAcceptsMarketing,
            'bg-green-100 text-green-800': order.isAcceptsMarketing
          }"
        >
          {{
            order.isAcceptsMarketing
              ? "Opted for messages"
              : "Not opted for messages"
          }}
        </span>
      </div>
    </td>

    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Customer Name
    </td>

    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900 truncate"
      style="max-width: 200px"
    >
      <a
        class="text-blue-500 cursor-pointer"
        @click="$emit('openCustomerInfo', order.customer.phoneNumber)"
      >
        {{ order.customer.firstName }} {{ order.customer.lastName }}
      </a>
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Total
    </td>

    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      {{ order.totalPrice }}
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Payment
    </td>

    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <span
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
        :class="{
          'bg-gray-100': order.financialStatus === 'paid',
          'bg-yellow-100': order.financialStatus !== 'paid'
        }"
      >
        {{ order.financialStatus }}
      </span>
    </td>

    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Fulfillment
    </td>

    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <span
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
        :class="{
          'bg-gray-100': order.fullfillmentStatus === 'fulfilled',
          'bg-yellow-100': order.fullfillmentStatus !== 'fulfilled'
        }"
      >
        {{ fullfillmentStatus }}
      </span>
    </td>

    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Message Sent
    </td>

    <td
      class="px-1 md:px-1 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <span
        class="inline-flex mx-1 my-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800"
        v-for="(template, index) in order.templateName"
        :key="index"
      >
        {{ template }}
      </span>
    </td>

    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <div class="mt-2">
        <span
          v-if="order.customerMeta && order.customerMeta.shouldNotDisturb"
          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
        >
          Do not disturb
          <button
            type="button"
            class="flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
            aria-label="Remove small badge"
            @click="removeTag('shouldNotDisturb')"
          >
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
        <span
          v-if="order.customerMeta && order.customerMeta.isNotOnWhatsapp"
          class="inline-flex mx-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
        >
          Not on Whatsapp
          <button
            type="button"
            class="flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
            aria-label="Remove small badge"
            @click="removeTag('isNotOnWhatsapp')"
          >
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
        <span v-if="order.orderTags" class="flex flex-wrap">
          <span
            class="inline-flex mx-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
            v-for="(tag, index) in order.orderTags.split(',')"
            :key="index"
          >
            {{ tag }}
          </span>
        </span>
      </div>

      <div class="mt-2">
        <AddTagDropdown @onItemClicked="addTag" />
      </div>
    </td>
    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap text-right border-b border-gray-200 text-xs leading-5 font-medium"
    >
      <OrderSendMessage :order="order" />
    </td>
  </tr>
</template>

<script>
import OrderSendMessage from "./OrderSendMessage";
import AddTagDropdown from "./AddTagDropdown";

import { format } from "date-fns";

export default {
  name: "OrderItem",
  components: {
    AddTagDropdown,
    OrderSendMessage
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      }
    },
    shopOrigin: {
      type: String,
      default: ""
    }
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  computed: {
    orderUrl() {
      return `https://${this.shopOrigin}/admin/orders/${this.order.orderId}`;
    },
    fullfillmentStatus() {
      if (this.order.fullfillmentStatus === null) {
        return "Unfullfilled";
      }
      return this.order.fullfillmentStatus;
    }
  },
  methods: {
    addTag(tag) {
      const obj = {};
      obj[tag] = true;
      this.$store.dispatch("updateOrderTag", {
        requestParams: obj,
        orderId: this.order.id
      });
      this.$emit("refreshCurrentPage");
    },
    removeTag(tag) {
      const obj = {};
      obj[tag] = false;
      this.$store.dispatch("updateOrderTag", {
        requestParams: obj,
        orderId: this.order.id
      });
      this.$emit("refreshCurrentPage");
    }
  }
};
</script>

<style lang="scss" scoped></style>
